/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetAllAssetTypeSubsystemComponentClassComponentTypesResponseDto } from './GetAllAssetTypeSubsystemComponentClassComponentTypesResponseDto';
import {
    GetAllAssetTypeSubsystemComponentClassComponentTypesResponseDtoFromJSON,
    GetAllAssetTypeSubsystemComponentClassComponentTypesResponseDtoFromJSONTyped,
    GetAllAssetTypeSubsystemComponentClassComponentTypesResponseDtoToJSON,
    GetAllAssetTypeSubsystemComponentClassComponentTypesResponseDtoToJSONTyped,
} from './GetAllAssetTypeSubsystemComponentClassComponentTypesResponseDto';

/**
 * 
 * @export
 * @interface GetAllMappingRes
 */
export interface GetAllMappingRes {
    /**
     * Array of asset-subsystem-component-type mappings
     * @type {Array<GetAllAssetTypeSubsystemComponentClassComponentTypesResponseDto>}
     * @memberof GetAllMappingRes
     */
    data: Array<GetAllAssetTypeSubsystemComponentClassComponentTypesResponseDto>;
    /**
     * Total number of mappings
     * @type {number}
     * @memberof GetAllMappingRes
     */
    total: number;
}

/**
 * Check if a given object implements the GetAllMappingRes interface.
 */
export function instanceOfGetAllMappingRes(value: object): value is GetAllMappingRes {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function GetAllMappingResFromJSON(json: any): GetAllMappingRes {
    return GetAllMappingResFromJSONTyped(json, false);
}

export function GetAllMappingResFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAllMappingRes {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(GetAllAssetTypeSubsystemComponentClassComponentTypesResponseDtoFromJSON)),
        'total': json['total'],
    };
}

export function GetAllMappingResToJSON(json: any): GetAllMappingRes {
    return GetAllMappingResToJSONTyped(json, false);
}

export function GetAllMappingResToJSONTyped(value?: GetAllMappingRes | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(GetAllAssetTypeSubsystemComponentClassComponentTypesResponseDtoToJSON)),
        'total': value['total'],
    };
}

